import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useLinks } from "../../hooks/links"
import { useAllOrders } from "../../hooks/orders"
import { localizeDateWithDay } from "../../utils"
import { useDisclosure, Button, Link } from "@chakra-ui/react"
import Page from "../../components/Admin/Page"
import OrderList from "../../components/Orders/OrderList"
import PrintMenu from "../../components/Printing/PrintMenu"
import EmptyState from "../../components/Common/EmptyState"

const OrdersPage = () => {
  const { linkId } = useParams()
  const createModalController = useDisclosure()

  const { links, isLoading: isLoadingLinks, toggleLink } = useLinks()
  const { orders, isLoading, updateOrder, removeOrder } = useAllOrders()

  const [currentOrders, setCurrentOrders] = useState([])
  const [currentLink, setCurrentLink] = useState()

  useEffect(() => {
    if (linkId) {
      setCurrentLink(links?.find((link) => link.id === linkId))
    } else {
      setCurrentLink(links?.[0])
    }
  }, [links, linkId])

  useEffect(
    () =>
      setCurrentOrders([
        ...orders.filter((item) => item.linkId === currentLink?.id),
      ]),
    [orders, currentLink]
  )

  return (
    <Page
      title={
        currentLink &&
        `Ordini: ${
          currentLink.name
            ? currentLink.name
            : localizeDateWithDay(currentLink?.startDate)
        }`
      }
      back={`/admin/ordini`}
      isLoading={isLoading || isLoadingLinks}
      toolbar={
        links.length > 0 && (
          <Fragment>
            <Button
              as={Link}
              colorScheme="teal"
              variant="outline"
              href={`/admin/ordini/verticale_zone/${currentLink?.id}`}
            >
              Riepilogo Verticale per Zone
            </Button>
            <Button
              as={Link}
              colorScheme="teal"
              variant="outline"
              href={`/admin/ordini/verticale/${currentLink?.id}`}
            >
              Riepilogo Verticale
            </Button>
            <Button
              colorScheme="teal"
              variant="outline"
              aria-label="Copia Link"
              onClick={(e) => {
                navigator.clipboard.writeText(
                  `${window.location.host}/${currentLink.id}`
                )
              }}
            >
              Copia Link
            </Button>
            <Button
              colorScheme={currentLink?.active ? "green" : "red"}
              onClick={() => {
                toggleLink(currentLink)
              }}
            >
              {currentLink?.active ? "Ordini Aperti" : "Ordini Chiusi"}
            </Button>
            <PrintMenu
              linkId={currentLink?.id}
              orderId=""
              hasFresco
              hasGastro
              withZones
            />
          </Fragment>
        )
      }
    >
      {links.length > 0 ? (
        <OrderList
          linkId={currentLink?.id}
          orders={currentOrders}
          updateOrder={updateOrder}
          removeOrder={removeOrder}
        />
      ) : (
        <EmptyState text="Non ci sono ancora link">
          <Button
            colorScheme="teal"
            size="lg"
            onClick={() => {
              createModalController.onOpen()
            }}
          >
            Crea il primo
          </Button>
        </EmptyState>
      )}
    </Page>
  )
}

export default OrdersPage
